<template>
	<div class="">
		<h1>Territory Report</h1>
		<hr>
		<!-- FILTER START -->
		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
			<h4 class="panel-title">Filter Option</h4>
			</template>
			<div class="row outerBox filterBox">
				<div class="col row">
					<!-- <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
					<label for="dateTimeInput">From</label>
					<flat-pickr
						v-model="filter.start"
						:config="seperatedRangeConfig"
						placeholder="Select From Date"
					/>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
					<label for="dateTimeInput">To</label>
					<flat-pickr
						v-model="filter.end"
						:config="seperatedRangeConfig"
						placeholder="Select To Date"
					/>
					</div> -->
					<div class="col-12 col-md-6">
						<label>Karesidenan</label>
						<Multiselect 
							:options="options.karesidenan.map(x => x.code)"
							:custom-label="opt => options.karesidenan.find(x => x.code  == opt).name"
							v-model="selected.karesidenan"
						/>
					</div>
					<div class="col-12 col-md-6">
						<label>City</label>
						<Multiselect 
							:options="options.city.map(x => x.code)"
							:custom-label="opt => options.city.find(x => x.code == opt).name"
							v-model="selected.city"
						/>
					</div>
					<div class="col-12 col-md-6">
						<label>Date Range</label>
						<flat-pickr
							v-model="selected.date"
							:config="rangeConfig"
							placeholder="Select To Date"
						/>
					</div>
					<div class="col-12 col-md-6">
						<label>Dealer</label>
						<Multiselect 
							:options="options.dealer.map(x => x.code)"
							:custom-label="opt => options.dealer.find(x => x.code == opt).name"
							v-model="selected.dealer"
						/>
					</div>
					<div class="col-md-4 row" style="padding-top:26px">
					<button class="btn btn-primary w-100" type="button" @click="search()">
						<span class="fa fa-filter"></span>&nbsp;&nbsp;Search
					</button>
					</div>
				</div>
			</div>
		</panel>

		<vue-universal-table 
			class="mt-5"
			v-if="data"
			:data="data"
			:fields="table.fields"
			:buttons="table.buttons"
			@onDownload="downloadDealerData"
		/>
	</div>
</template>

<script>
import moment from 'moment'
const XLSX = require('xlsx')
import Datepicker from 'vuejs-datepicker'
import Multiselect  from 'vue-multiselect'
import flatPickr from 'vue-flatpickr-component'
import Vue_universal_table from '../../../../components/table/vue_universal_table.vue'

export default {
	components : {
		Multiselect, 
		flatPickr,
		Vue_universal_table
	},
	data () {
		let date = `${new moment().startOf('month').format('Y-MM-DD')} to ${new moment().endOf('month').format('Y-MM-DD')}`
		return {
			data : null,
			options : this.$store.getters.getFilterOptions,
			rangeConfig: {
				mode: 'range',
				altInput: true,
				altInputClass: 'form-control input flatpickr-input',
				animate: !this.isRTL()
			},
			
			selected : {
				date : date,
				karesidenan : null,
				dealer : null,
				city : null
			},
			filter : {
				start : date.split(' to ')[0],
				end : date.split(' to ')[1],
				karesidenan : null,
				dealer : null,
				city : null
			},
			table : {
				update : 0,
				buttons : [{
					title : 'Download',
					class : 'fas fa-download btn-outline-primary',
					variable : 'kd_dealer',
				}],
				fields : [{
					title : 'Dealer Code',
					variable : 'kd_dealer'
				}, {
					title : 'Dealer Name',
					variable : 'name'
				},{
					title : 'Total Delivery',
					variable : 'total_delivery'
				}, {
					title : 'Scan in Dealer ( < 20m )',
					variable : 'in_dealer'
				}, {
					title : 'Scan out Dealer ( < 20m )',
					variable : 'out_dealer'
				},{
					title : 'Sales Quantity',
					variable : 'total_sales'
				},{
					title : 'Undelivered Vehicles',
					variable : 'undelivered'
				}]
			}
		}
	},
	watch : {
		'selected.karesidenan' : function () {
			this.loadFilter('karesidenan')
		},
		'selected.city' : function () {
			this.loadFilter('city')
		}
	},
	mounted () {
		this.loadData()
	},
	methods : {
		async loadData() {
			this.data = null
			let stringUrl = await this.initialiseFilter()

			this.$http.get('/api/reports/delivery-report' + stringUrl)
			.then((resp) => {
				this.data = resp.data.data
			})
			.catch((err)=> {
				console.log(err)
			})
		},
		search() {
			let obj = Object.assign({} , this.selected)
			obj.start = obj.date.split(' to ')[0]
			obj.end = obj.date.split(' to ')[1]
			delete obj.date;

			this.filter = obj
			
			this.loadData()
		},
		loadFilter(type){
			let city = []
			if(this.selected.city) city.push({code : this.selected.city})

			let karesidenan = []
			if(this.selected.karesidenan) karesidenan.push({code : this.selected.karesidenan})

			if (type == 'karesidenan'){
				this.selected.city = null;
				this.options.city = this.$store.getters.getCity(karesidenan)
				
				this.selected.dealer= null;
				this.options.dealer = this.$store.getters.getDealer(karesidenan, city)
			} else if (type == 'city'){
				this.selected.dealer = null;
				this.options.dealer = this.$store.getters.getDealer(karesidenan, city)
			} 
		},
		initialiseFilter(){
			if(!(typeof this.filter === 'object' && this.filter !== null)){
				this.filterUrl = '';
				return;
			}
			var keys = Object.keys(this.filter);
			let stringUrl = '?';
			var queryParams = this.filter;

			for(var i = 0 ; i < keys.length; i++){
				if(!queryParams[keys[i]])
					continue;

				if(queryParams[keys[i]] == '' || queryParams[keys[i]].length == 0)
					continue 

				if((keys[i] == 'user_type') && queryParams[keys[i]] == 'All')
					continue;
				
				// if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
				//   queryParams[keys[i]] += ":00";
				
				if([keys[i]] == 'start' || keys[i] == 'end') queryParams[keys[i]] = moment(queryParams[keys[i]]).format('Y-MM-DD')
				

				stringUrl += `&${keys[i]}=${queryParams[keys[i]]}`;
			
			}
			console.log(stringUrl)
			return stringUrl;
		},
		downloadDealerData (dealerCode) {
			this.$http.get(`/api/reports/delivery-report/by-dealer?start=${this.filter.start}&end=${this.filter.end}&dealer=${dealerCode.replace(/"/g, "")}`)
			.then((resp)=>{
				this.exportFile(resp.data.data);
			})
			.catch((err)=>{console.log(err)})
		},
		exportFile(data){
			let wb = XLSX.utils.book_new()
			var ws = XLSX.utils.json_to_sheet(data, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws, 'Data')

			let exportFileName = `Export Territory Report ${this.filter.start} - ${this.filter.end}.xlsx`
			XLSX.writeFile(wb, exportFileName)
		},
	}
}
</script>